import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import * as asyncPages from "./asyncPages";
import * as providers from "./asyncProviders";
// @ts-ignore

import { URL_SELL_TRADE_FORM, URL_SELL_TRADE_LANDING } from "@/pages/module-sell-trade/SellTradeContext";
import { CARS_PRICES_BASE_PATH } from "@/pages/car-prices/helpers/carsPricesHelpers";
export var PageNamesEnum = /*#__PURE__*/function (PageNamesEnum) {
  PageNamesEnum["PAGE_NAME__Home"] = "Home";
  PageNamesEnum["PAGE_NAME__PostView"] = "Post View";
  PageNamesEnum["PAGE_NAME__SERP"] = "Search";
  PageNamesEnum["PAGE_NAME__AUTOS"] = "Autos";
  PageNamesEnum["PAGE_NAME__TrendPermalink"] = "Trend Permalink";
  PageNamesEnum["PAGE_NAME__Trend"] = "Trend";
  PageNamesEnum["PAGE_NAME__CarShowRooms"] = "Car Show Rooms";
  PageNamesEnum["PAGE_NAME__Cities"] = "Cities";
  PageNamesEnum["PAGE_NAME__SingleCity"] = "Single city";
  PageNamesEnum["PAGE_NAME__FinancingPageRoot"] = "Financing Page Root";
  PageNamesEnum["PAGE_NAME__CarPricesPageRoot"] = "Car prices Page Root";
  PageNamesEnum["PAGE_NAME__MobileOffers"] = "Mobile Offers";
  PageNamesEnum["PAGE_NAME__FaqPage"] = "Faq Page";
  PageNamesEnum["PAGE_NAME__LandingPageRoot"] = "Landing Page Root";
  PageNamesEnum["PAGE_NAME__PostViewInspection"] = "Post View Inspection";
  PageNamesEnum["PAGE_NAME__PRIVACY_POLICY"] = "Privacy Policy";
  PageNamesEnum["PAGE_NAME__AFFILIATE"] = "Affiliate";
  PageNamesEnum["PAGE_NAME__EMBED_FILTERS"] = "Embed Filters";
  return PageNamesEnum;
}({});
export default function extractedRoutes() {
  //import * as ssrData from "../ssrData";
  // load SSR data only when on server
  // mock ssrData for client
  var ssrData = {};
  var testRoutes = function testRoutes() {
    return [];
  };
  //__IS_SSR__ is a global variable defined by Webpack
  if (__IS_SSR__) {
    ssrData = require("./ssrData");
  }
  if (!__IS_PROD_ENV__) {
    testRoutes = require("./testRoutes")["default"];
  }
  var routes = [].concat(_toConsumableArray(testRoutes()), [{
    path: ["/"],
    component: asyncPages.HomePageV2,
    getFullPageData: ssrData.homeFullPageData,
    getSeoData: ssrData.seoData__home,
    name: PageNamesEnum.PAGE_NAME__Home,
    exact: true
  }, {
    path: ["/years", "/years/:year", "/years/:year/:make"],
    component: asyncPages.SearchRenderer,
    getFullPageData: ssrData.newSearchFullPageData,
    getHeaderTags: ssrData.searchHeaderTags,
    getSeoData: ssrData.seoData__search,
    name: PageNamesEnum.PAGE_NAME__SERP,
    exact: false
  }, {
    path: ["/home/new-cars" // keep this path for Redirection to /autos/new-cars
    , "/autos", "/autos/new-cars", "/autos/used-cars"],
    component: asyncPages.AutosRenderer,
    getFullPageData: ssrData.autosFullPageData,
    getSeoData: ssrData.seoData__autos,
    name: PageNamesEnum.PAGE_NAME__AUTOS,
    exact: true
  }, {
    path: ["/autos/:make", "/autos/:make/:model", "/autos/:make/:model/:year"],
    component: asyncPages.AutosRenderer,
    getFullPageData: ssrData.newSearchFullPageData,
    getHeaderTags: ssrData.searchHeaderTags,
    getSeoData: ssrData.seoData__search,
    name: PageNamesEnum.PAGE_NAME__SERP,
    exact: false
  }, {
    path: ["/user/signup/*", "/user/login/*"],
    component: asyncPages.SignUp,
    webViewSupported: true,
    name: "signUp",
    getSeoData: ssrData.seoData__userAccount
  }, {
    path: ["/car/similar-cars/:postId", "/car/similar-cars/:postId/*"],
    component: asyncPages.SimilarPosts,
    name: "SimilarPosts Posts",
    exact: true
  }, {
    path: ["/car/:id", "/car/:id/*", "/cardetail/:id", "/cardetail/:id/*"],
    component: asyncPages.PostViewPage,
    // getInitialData: ssrData.postInitialData,
    getFullPageData: ssrData.postFullPageData,
    getHeaderTags: ssrData.postHeaderTags,
    getSeoData: ssrData.seoData__post,
    name: PageNamesEnum.PAGE_NAME__PostView,
    providers: [providers.PostDetailsContextProvider],
    exact: true
  }, {
    path: ["/تسويق_بالعمولة", "/network"],
    component: asyncPages.Affiliate,
    //getHeaderTags: ssrData.affiliateHeaderTags,
    getSeoData: ssrData.seoData__affiliate,
    getFullPageData: ssrData.affiliateFullPageData,
    name: PageNamesEnum.PAGE_NAME__AFFILIATE
  }, {
    path: ["/faq"],
    component: asyncPages.FaqPage,
    getFullPageData: ssrData.faqFullPageData,
    getHeaderTags: ssrData.faqsHeaderTags,
    name: "Faq Page",
    webViewSupported: true,
    exact: true
  }, {
    path: ["/feedback"],
    component: asyncPages.Reviews,
    getHeaderTags: ssrData.reviewsHeaderTags,
    webViewSupported: true,
    name: "Reviews",
    exact: true
  }, {
    path: ["/privacy-policy", "/privacy-policy/*", "/terms", "/terms-landing", "/terms-landing/*", "/car-purchase-terms-conditions", "/car-purchase-terms-conditions/*"],
    component: asyncPages.StaticPage,
    getSeoData: ssrData.seoData__static,
    getFullPageData: ssrData.getFullPageData__static,
    webViewSupported: true,
    name: PageNamesEnum.PAGE_NAME__PRIVACY_POLICY,
    exact: true
  }, {
    path: ["/about-us"],
    component: asyncPages.AboutUs,
    getHeaderTags: ssrData.aboutUsHeaderTags,
    getSeoData: ssrData.seoData__AboutUsPage,
    name: "About Us",
    webViewSupported: true,
    exact: true
  }, {
    path: ["/about-us/services"],
    component: asyncPages.Services,
    getHeaderTags: ssrData.servicesHeaderTags,
    name: "Services",
    webViewSupported: true,
    exact: true
  }, {
    path: ["/offerspage"],
    component: asyncPages.MobileOffers,
    getFullPageData: ssrData.offersFullPageData,
    getHeaderTags: ssrData.offersHeaderTags,
    getSeoData: ssrData.seoData__offers,
    name: "Mobile Offers",
    exact: true
  }, {
    path: ["/contact-us"],
    component: asyncPages.Contact,
    webViewSupported: true,
    getHeaderTags: ssrData.contactHeaderTags,
    name: "contact"
  }, {
    path: ["/checkout/shop-apply", "/checkout/shop-apply/*"],
    component: asyncPages.ShopApply,
    name: "check Out step one (shop apply)",
    exact: true,
    providers: [providers.CheckoutOrderContextProvider],
    getSeoData: ssrData.seoData__checkoutPage
  }, {
    path: ["/checkout/create-araboon"],
    component: asyncPages.CheckoutRendererV2,
    name: "check Out payment",
    exact: true,
    shouldAuth: true,
    webViewSupported: true,
    providers: [providers.CheckoutOrderContextProvider],
    getSeoData: ssrData.seoData__checkoutPage
  }, {
    path: ["/payedsuccess"],
    component: asyncPages.CheckoutSuccess,
    name: "checkout success page",
    exact: true,
    webViewSupported: true,
    providers: [providers.CheckoutOrderContextProvider]
  }, {
    path: ["/payedfailed"],
    component: asyncPages.CheckoutFailed,
    name: "checkout failed page",
    exact: true,
    webViewSupported: true,
    providers: [providers.CheckoutOrderContextProvider]
  }, {
    path: ["/tracking-landing"],
    component: asyncPages.TrackingLandingNew,
    name: "tracking",
    exact: true,
    shouldAuth: true,
    webViewSupported: true,
    login_event_tracking__IS_IT_NEEDED: "order_tracking"
  }, {
    path: ["/tracking-finance-details", "/tracking-finance-details/:orderId"],
    component: asyncPages.TrackingFinanceDetails,
    name: "tracking finance details",
    exact: true,
    shouldAuth: true,
    webViewSupported: true,
    login_event_tracking__IS_IT_NEEDED: "order_tracking"
  }, {
    path: ["/tracking-checkout-details", "/tracking-checkout-details/:orderId"],
    component: asyncPages.TrackingCheckoutDetails,
    name: "tracking checkout details",
    exact: true,
    shouldAuth: true,
    webViewSupported: true,
    login_event_tracking__IS_IT_NEEDED: "order_tracking"
  }, {
    path: ["/tracking-checkout-details", "/tracking-checkout-details/:orderId/:stepNum"],
    component: asyncPages.TrackingCheckoutStepDetails,
    name: "tracking checkout step details",
    exact: true,
    shouldAuth: true,
    webViewSupported: true,
    login_event_tracking__IS_IT_NEEDED: "order_tracking"
  }, {
    path: ["/tracking-finance-details", "/tracking-finance-details/:orderId/:stepNum"],
    component: asyncPages.TrackingFinanceStepDetails,
    name: "tracking finance step details",
    exact: true,
    shouldAuth: true,
    webViewSupported: true,
    login_event_tracking__IS_IT_NEEDED: "order_tracking"
  }, {
    path: ["/tracking-checkout-details", "/tracking-checkout-details/view-all-offered-doc/:orderId"],
    component: asyncPages.TrackingCheckoutViewAllOfferedDoc,
    name: "tracking checkout step details",
    exact: true,
    shouldAuth: true,
    webViewSupported: true,
    login_event_tracking__IS_IT_NEEDED: "order_tracking"
  }, {
    path: ["/tracking-finance-details", "/tracking-finance-details/view-all-offered-doc/:orderId"],
    component: asyncPages.TrackingFinanceViewAllOfferedDoc,
    name: "tracking finance step details",
    exact: true,
    shouldAuth: true,
    webViewSupported: true,
    login_event_tracking__IS_IT_NEEDED: "order_tracking"
  }, {
    path: ["/car-info/:id"],
    component: asyncPages.CarInfo,
    getFullPageData: ssrData.postCarInfoFullPageData,
    providers: [providers.PostDetailsContextProvider],
    webViewSupported: true,
    name: "car info",
    exact: true
  }, {
    path: ["/referral/:id"],
    component: asyncPages.Referral,
    name: "referral",
    exact: true,
    shouldAuth: true
  }, {
    path: ["/referral-list/:id/:listType"],
    component: asyncPages.ReferralList,
    name: "referral list",
    shouldAuth: true
  }, {
    path: ["/orders/customer-survey", "/orders/customer-survey/:order_id/*", "/orders/customer-cancelled-survey", "/orders/customer-cancelled-survey/:order_id/*"],
    component: asyncPages.Survey,
    name: "NPS Survey",
    webViewSupported: true,
    exact: true,
    shouldAuth: true
  }, {
    path: ["/remaining-payment/:id"],
    component: asyncPages.RemainingPayment,
    name: "remaining payment",
    webViewSupported: true,
    exact: true
  }, {
    path: ["/paylink/:uuid"],
    component: asyncPages.PayLink,
    getFullPageData: ssrData.payLinkFullPageData,
    name: "Pay Link",
    webViewSupported: true,
    exact: true
  }, {
    path: "/page404",
    component: asyncPages.page404,
    name: "page404",
    webViewSupported: true,
    exact: true
  }, {
    path: ["/finance-apply-free/:id"],
    component: asyncPages.FinanceFormPageFree,
    name: "finance",
    exact: true
  }, {
    path: ["/finance-apply-arib"],
    component: asyncPages.AribFinancePage,
    name: "finance",
    exact: true,
    webViewSupported: true
  },
  //tamara ====================================
  {
    path: ["/finance-apply-tamara"],
    component: asyncPages.TamaraFinancePage,
    name: "finance",
    exact: true,
    webViewSupported: true,
    providers: [providers.TamaraFinanceContextProvider]
  }, {
    path: ["/finance-apply-tamara/payment-success"],
    component: asyncPages.TamaraSuccessPage,
    name: "finance",
    exact: true,
    webViewSupported: true
  }, {
    path: ["/finance-apply-tamara/payment-failed"],
    component: asyncPages.TamaraFailedPage,
    name: "finance",
    exact: true,
    webViewSupported: true
  }, {
    path: ["/finance-apply-tamara/payment-cancel"],
    component: asyncPages.TamaraCancelPage,
    name: "finance",
    exact: true,
    webViewSupported: true
  },
  //tabby ====================================
  {
    path: ["/finance-apply-tabby"],
    component: asyncPages.TabbyFinancePage,
    name: "finance",
    exact: true,
    webViewSupported: true,
    providers: [providers.TabbyFinanceContextProvider]
  }, {
    path: ["/finance-apply-tabby/payment-success"],
    component: asyncPages.TabbySuccessPage,
    name: "finance",
    exact: true,
    webViewSupported: true
  }, {
    path: ["/finance-apply-tabby/payment-failed"],
    component: asyncPages.TabbyFailedPage,
    name: "finance",
    exact: true,
    webViewSupported: true
  }, {
    path: ["/finance-apply-tabby/payment-cancel"],
    component: asyncPages.TabbyCancelPage,
    name: "finance",
    exact: true,
    webViewSupported: true
  }, {
    path: ["/finance-apply-tabby/payment-cancel-exceeds-limit"],
    component: asyncPages.TabbyCancelAmountHighPage,
    name: "finance",
    exact: true,
    webViewSupported: true
  }, {
    path: ["/finance-apply-tabby/payment-cancel-low-limit"],
    component: asyncPages.TabbyCancelAmountLowPage,
    name: "finance",
    exact: true,
    webViewSupported: true
  },
  //amwal ====================================
  {
    path: ["/finance-apply-amwal"],
    component: asyncPages.AmwalFinancePage,
    name: "finance",
    exact: true,
    webViewSupported: true,
    providers: [providers.AmwalFinanceContextProvider]
  }, {
    path: ["/finance-apply-amwal/payment-status"],
    component: asyncPages.AmwalPaymentStatusPage,
    name: "finance",
    exact: true,
    webViewSupported: true
  }, {
    path: ["/process-payment-moyasar-callback", "/process-payment-moyasar-callback/*"],
    component: asyncPages.MoyasarPaymentProcessing,
    name: "payment Processing",
    exact: true,
    webViewSupported: true,
    providers: [providers.CheckoutOrderContextProvider]
  }, {
    path: ["/finance/rejected", "/finance/rejected/*"],
    component: asyncPages.FinanceRejectedPage,
    name: "Finance rejected",
    webViewSupported: true,
    exact: true
  }, {
    path: ["/user/account"],
    component: asyncPages.UserAccount,
    name: "user account",
    exact: true,
    shouldAuth: true,
    getSeoData: ssrData.seoData__userAccount,
    login_event_tracking__IS_IT_NEEDED: "user-account"
  }, {
    path: ["/user/favorite"],
    component: asyncPages.UserFavorite,
    name: "user favorite",
    exact: true,
    shouldAuth: true,
    getSeoData: ssrData.seoData__userAccount,
    login_event_tracking__IS_IT_NEEDED: "user-account"
  }, {
    path: ["/user/account/my-info"],
    component: asyncPages.UserInfo,
    name: "user info",
    shouldAuth: true,
    getSeoData: ssrData.seoData__userAccount,
    login_event_tracking__IS_IT_NEEDED: "user-account"
  }, {
    path: ["/user/account/my-info/edit-name"],
    component: asyncPages.UserEditName,
    name: "user edit name",
    shouldAuth: true,
    getSeoData: ssrData.seoData__userAccount,
    login_event_tracking__IS_IT_NEEDED: "user-account"
  }, {
    path: ["/user/account/my-info/edit-mobile"],
    component: asyncPages.UserEditMobile,
    name: "user edit mobile",
    shouldAuth: true,
    getSeoData: ssrData.seoData__userAccount,
    login_event_tracking__IS_IT_NEEDED: "user-account"
  }, {
    path: ["/pre-checkout", "/pre-checkout/:postId"],
    component: asyncPages.PreCheckout,
    name: "pre checkout",
    exact: true,
    providers: [providers.CheckoutOrderContextProvider],
    getSeoData: ssrData.seoData__preCheckoutPage
  }, {
    path: ["/filters", "/filters/*", "/deal/:dealId"],
    component: asyncPages.SearchRenderer,
    getFullPageData: ssrData.newSearchFullPageData,
    getHeaderTags: ssrData.searchHeaderTags,
    name: "filters",
    exact: true
  }, {
    path: ["/service-centers"],
    component: asyncPages.ServiceCenters,
    getHeaderTags: ssrData.serviceSentersHeaderTags,
    getSeoData: ssrData.seoData__serviceCenters,
    name: "ServiceCenters",
    exact: true
  }, {
    path: ["/service-centers/filters"],
    component: asyncPages.ServiceCentersFilters,
    name: "ServiceCenters",
    exact: true
  }, {
    path: ["/healthcheck"],
    component: asyncPages.healthcheck,
    name: "healthCheck"
  }, {
    path: ["/trend/:permalink"],
    component: asyncPages.SingleTrend,
    getFullPageData: ssrData.getFullPageData__SingleTrend,
    getHeaderTags: ssrData.SingleTrendHeaderTags,
    getSeoData: ssrData.seoData__SingleTrend,
    name: "Trend Permalink"
  }, {
    path: ["/trend"],
    component: asyncPages.Trends,
    getFullPageData: ssrData.getFullPageData__Trends,
    getSeoData: ssrData.seoData__trends,
    getHeaderTags: ssrData.TrendsHeaderTags,
    name: "Trend"
  }, {
    path: ["/city/:cityName"],
    component: asyncPages.SingleCityPage,
    //getInitialData: ssrData.SingleCityInitialData,
    getFullPageData: ssrData.singleCityFullPageData,
    getHeaderTags: ssrData.SingleCityHeaderTags,
    name: "Single city"
  }, {
    path: ["/city"],
    component: asyncPages.CitiesPage,
    //getInitialData: ssrData.CitiesInitialData,
    getFullPageData: ssrData.citiesFullPageData,
    getHeaderTags: ssrData.CitiesHeaderTags,
    name: "Cities"
  }, {
    path: ["/report/:id", "/report/:id/*"],
    component: asyncPages.InspectionViewPage,
    getFullPageData: ssrData.inspectionFullPageData,
    getHeaderTags: ssrData.inspectionHeaderTags,
    name: PageNamesEnum.PAGE_NAME__PostViewInspection,
    shouldAuth: true,
    webViewSupported: true,
    providers: [providers.PostDetailsContextProvider],
    exact: true
  }, {
    path: ["/tracking-report/:id", "/tracking-report/:id/*"],
    component: asyncPages.InspectionViewPage,
    getFullPageData: ssrData.inspectionTrackingFullPageData,
    name: PageNamesEnum.PAGE_NAME__PostViewInspection,
    shouldAuth: true,
    webViewSupported: true,
    providers: [providers.PostDetailsContextProvider],
    exact: true
  }, {
    path: ["/car-showrooms"],
    component: asyncPages.CarShowRooms,
    // getInitialData: ssrData.CarRoomsInitialData,
    getFullPageData: ssrData.carRoomsFullPageData,
    getHeaderTags: ssrData.carRoomsHeaderTags,
    name: "Car Show Rooms",
    exact: true
  }, {
    path: ["/schedule/:request_id"],
    component: asyncPages.Schedule,
    name: "Schedule",
    webViewSupported: true,
    exact: true
  }, {
    path: [URL_SELL_TRADE_FORM],
    component: asyncPages.SellTradeForm,
    name: "Sell Trade Form",
    webViewSupported: true,
    exact: true
  }, {
    path: ['/site/sell-my-car'],
    component: asyncPages.SellMyCarForm,
    name: "Sell my car Form",
    exact: true,
    webViewSupported: true
  }, {
    path: ["/site/sell-my-car-landing"],
    component: asyncPages.SellTradePageV2,
    getSeoData: ssrData.seoData__SellTrade__v3,
    getFullPageData: ssrData.getFullPageData__SellTrade,
    webViewSupported: true,
    name: "Sell Trade Landing",
    exact: true
  }, {
    path: [URL_SELL_TRADE_LANDING],
    component: asyncPages.SellTradePage,
    getSeoData: ssrData.seoData__SellTrade,
    webViewSupported: true,
    name: "Enhanced Sell Trade Form",
    exact: true
  }, {
    path: ["/site/sell-trade-terms"],
    component: asyncPages.SellTradeTermsPage,
    webViewSupported: true,
    name: "Sell Trade Terms",
    exact: true
  },
  // order is important
  {
    path: ["/lp/*", "/financing/calculator"],
    component: asyncPages.LandingPageRoot,
    getFullPageData: ssrData.LandingPageFullPageData,
    getHeaderTags: ssrData.LandingPageHeaderTags,
    getSeoData: ssrData.seoData__landing,
    webViewSupported: true,
    name: "Landing Page Root",
    exact: true
  }, {
    path: [CARS_PRICES_BASE_PATH, CARS_PRICES_BASE_PATH + "/*"],
    component: asyncPages.carsPrices,
    getFullPageData: ssrData.carsPricesPageFullPageData,
    getSeoData: ssrData.seoData__carsPrices,
    name: PageNamesEnum.PAGE_NAME__CarPricesPageRoot,
    exact: true
  }, {
    path: ["/تقسيط-سيارات", "/financing", "/financing/*"],
    component: asyncPages.FinancingPageRoot,
    getFullPageData: ssrData.financingPageFullPageData,
    getHeaderTags: ssrData.financeHeaderTags,
    getSeoData: ssrData.financeSeoData,
    name: "Financing Page Root",
    webViewSupported: true,
    exact: true
  }, {
    path: ['/finance-calculator-webview/:id'],
    component: asyncPages.FinanceCalculatorWebview,
    name: 'Finance Calculator Webview',
    webViewSupported: true,
    exact: true
    //FIXME: add provider and clean Component level fetching
    // providers: [
    //   providers.PostDetailsContextProvider,
    // ]
  }, {
    path: ['/site/recommendation-list'],
    component: asyncPages.RecommendationList,
    name: 'Recommendation List',
    getSeoData: ssrData.seoData__sitePages,
    exact: true
  }, {
    path: ['/site/unsubscribe-interest'],
    component: asyncPages.UnsubscribeInterest,
    name: 'Unsubscribe Interest',
    webViewSupported: true,
    exact: true,
    getSeoData: ssrData.seoData__sitePages
  }, {
    path: ['/site/new-arrivals'],
    component: asyncPages.NewArrivals,
    name: 'New Arrival',
    exact: true,
    getSeoData: ssrData.seoData__sitePages
  }, {
    path: ["/tracking-return-wizard/:order_uuid"],
    component: asyncPages.TrackingReturnWizard,
    name: "Tracking Finance Return",
    webViewSupported: true,
    exact: true,
    shouldAuth: true
  }, {
    path: ["/site/car-compare"],
    component: asyncPages.CarComparison,
    name: "Car Comparison",
    exact: true,
    shouldAuth: true,
    getSeoData: ssrData.seoData__sitePages
  }, {
    path: ["/site/recently-viewed"],
    component: asyncPages.recentlyViewed,
    name: "Car Comparison",
    exact: true,
    getSeoData: ssrData.seoData__sitePages
  }, {
    path: ["/site/saved-search"],
    component: asyncPages.SavedSearch,
    name: "Saved Search",
    exact: true,
    shouldAuth: true,
    getSeoData: ssrData.seoData__sitePages
  }, {
    path: ["/site/finance-eligibility"],
    component: asyncPages.FinanceEligibility,
    name: "Finance Eligibility",
    exact: true,
    getSeoData: ssrData.seoData__sitePages
  }, {
    path: ["/site/finance-eligibility/disqualified"],
    component: asyncPages.FinanceDisqualified,
    name: "Finance Disqualified",
    exact: true,
    getSeoData: ssrData.seoData__sitePages
  }, {
    path: ["/compare"],
    component: asyncPages.ComparePage,
    getHeaderTags: ssrData.comparePageHeaderTags,
    getSeoData: ssrData.seoData__ComparePage,
    name: "Compare Page",
    exact: true
  }, {
    path: ["/site/price-offer/:request_id"],
    component: asyncPages.PriceOfferFlowPage,
    name: "Price Offer Flow Page",
    exact: true,
    providers: [providers.PriceOfferContextProvider],
    getSeoData: ssrData.seoData__sitePages
  }, {
    path: ["/site/dhamen/:uuid"],
    component: asyncPages.DhamenFlowPage,
    name: "Dhamen Flow Page",
    exact: true,
    providers: [providers.DhamenContextProvider],
    getSeoData: ssrData.seoData__sitePages
  }, {
    path: ["/embed/filters"],
    component: asyncPages.EmbedFilters,
    getFullPageData: ssrData.embedFiltersFullPageData,
    exact: true,
    name: "Embed Filters"
  }, {
    path: ["/finance-remaining-payment/:order_uuid"],
    component: asyncPages.FinanceRemainingPayment,
    name: "finance remaining payment",
    exact: true,
    shouldAuth: true
  }, {
    path: ["/site/sell-my-car/payment-failed/:request_id"],
    component: asyncPages.SellMyCarPaymentFailed,
    exact: true,
    shouldAuth: true,
    webViewSupported: true
  }, {
    path: ["/site/sell-my-car/rejected"],
    component: asyncPages.SellMyCarRejected,
    exact: true
  }]);
  var paths = [];
  routes.forEach(function (element) {
    if (Array.isArray(element.path)) {
      element.path.forEach(function (path) {
        paths.push(_objectSpread(_objectSpread({}, element), {}, {
          path: path
        }));
        paths.push(_objectSpread(_objectSpread({}, element), {}, {
          path: "/en" + path
        }));
      });
    } else {
      paths.push(element);
      paths.push(_objectSpread(_objectSpread({}, element), {}, {
        path: "/en" + element.path
      }));
    }
  });
  return paths;
}